import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { CategoryDetailsPageContext } from "@insite/content-library/Pages/CategoryDetailsPage";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    id: string;
}

const mapStateToProps = (state: ApplicationState) => ({
    location: getLocation(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const ADICustomCategoriesWidget: React.FC<Props> = ({ id, location }) => {
    const pathname = location.pathname;
    const parts = pathname.split("/");

    return parts.length > 4 ? (
        <StyledWrapper>
            <Zone contentId={id} zoneName="L2Content"></Zone>
        </StyledWrapper>
    ) : (
        <StyledWrapper>
            <Zone contentId={id} zoneName="L1Content"></Zone>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ADICustomCategoriesWidget),
    definition: {
        group: "Basic",
        displayName: "ADI Custom Widget",
        allowedContexts: [CategoryDetailsPageContext],
    },
};

export default widgetModule;
